export enum PaymentPaneStatus {
  Error = 'error',
  Success = 'success',
}
